import styled from 'styled-components';

export const TopBar = styled.div`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: #000;
  z-index: 1000;
  padding: 0 16px;
  align-items: center;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const HamburgerButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;

  span {
    display: block;
    width: 100%;
    height: 3px;
    background-color: #fff;
    transition: 0.4s;
    border-radius: 2px;
  }

  &.open {
    span:nth-child(1) {
      transform: rotate(-45deg) translate(-7px, 6px);
    }

    span:nth-child(2) {
      opacity: 0;
    }

    span:nth-child(3) {
      transform: rotate(45deg) translate(-7px, -6px);
    }
  }
`;
